import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';
import ListSubheader from '@material-ui/core/ListSubheader';

const PickItemPropertySkeleton = ({ label }) => (
  <>
    <ListSubheader component="div" disableGutters disableSticky>
      <Typography variant="overline" color="textSecondary">
        {label}
      </Typography>
    </ListSubheader>
    <Skeleton variant="rect" height={48} width={150} />
  </>
);

PickItemPropertySkeleton.propTypes = {
  label: PropTypes.string.isRequired,
};

export default PickItemPropertySkeleton;
